import { lazy } from 'react';
// 分销交易订单
const DistributionTrade = lazy(() => import('pages/distributionTrade'));
// 分销退款订单
const DistributionRefund = lazy(() => import('pages/distributionRefund'));
// 采购交易订单
const PurchaseTrade = lazy(() => import('pages/purchaseTrade'));
// 采购退款订单
const PurchaseRefund = lazy(() => import('pages/purchaseRefund'));
// 预警通知
const WarningNotice = lazy(() => import('pages/warningNotice'));
// 分销应付管理
const DistributionPay = lazy(() => import('pages/distributionPay'));
// 分销应付管理详情
const DistributionPayDetail = lazy(() => import('pages/distributionPayDetail'));
// 分销交易订单
const DistributionTradeNew = lazy(() => import('pages/distributionTradeNew'));
// 采购交易订单
const PurchaseTradeNew = lazy(() => import('pages/purchaseTradeNew'));
// 交易记录管理（旧）
const TradeRecordManagement = lazy(() => import('pages/tradeRecordManagement'));
// 交易记录管理（新）
const TradeRecordMng = lazy(() => import('pages/tradeRecordMng'));
// 提现记录
const WithdrawalRecord = lazy(() => import('pages/withdrawalRecord'));
// 结算记录管理
const SettleRecordManagement = lazy(() => import('pages/settleRecordManagement'));
// 保证金凭证
const BondVoucher = lazy(() => import('pages/bondVoucher'));
// 线下渠道分账管理
const OffLineAccountList = lazy(() => import('pages/offLineAccountList'));
// 线下渠道分账管理详情
const OffLineAccountDetail = lazy(() => import('pages/offLineAccountDetail'));

export const router = {
    path: '/finance',
    name: '财务报表',
    icon: 'bank',
    permission: 107,
    children: [
        {
            path: 'distributionTrade',
            name: '分销交易订单(旧)',
            icon: 'profile',
            permission: 10701,
            component: DistributionTrade,
        },
        {
            path: 'distributionRefund',
            name: '分销退款订单(旧)',
            icon: 'profile',
            permission: 10702,
            component: DistributionRefund,
        },
        {
            path: 'purchaseTrade',
            name: '采购交易订单(旧)',
            icon: 'profile',
            permission: 10703,
            component: PurchaseTrade,
        },
        {
            path: 'purchaseRefund',
            name: '采购退款订单(旧)',
            icon: 'profile',
            permission: 10704,
            component: PurchaseRefund,
        },
        {
            path: 'warningNotice',
            name: '预警通知(旧)',
            icon: 'warning',
            permission: 10705,
            component: WarningNotice,
        },
        {
            path: 'distributionPay',
            name: '分销应付管理',
            icon: 'profile',
            permission: 10706,
            component: DistributionPay,
        },
        {
            path: 'distributionPayDetail/:merchantFid',
            name: '分销应付管理详情',
            icon: 'profile',
            hideInMenu: true,
            permission: 10706,
            component: DistributionPayDetail,
        },
        {
            path: 'distributionTradeNew',
            name: '分销交易订单',
            icon: 'profile',
            permission: 10707,
            component: DistributionTradeNew,
        },
        {
            path: 'purchaseTradeNew',
            name: '采购交易订单',
            icon: 'profile',
            permission: 10708,
            component: PurchaseTradeNew,
        },
        {
            path: 'tradeRecordManagement',
            name: '交易记录管理(旧)',
            icon: 'profile',
            permission: 10709,
            component: TradeRecordManagement,
        },
        {
            path: 'tradeRecordMng',
            name: '交易记录管理(新)',
            icon: 'profile',
            permission: 10711,
            component: TradeRecordMng,
        },
        {
            path: 'withdrawalRecord',
            name: '提现记录',
            icon: 'profile',
            permission: 10712,
            component: WithdrawalRecord,
        },
        {
            path: 'settleRecordManagement',
            name: '结算记录管理',
            icon: 'profile',
            permission: 10710,
            component: SettleRecordManagement,
        },
        {
            path: 'bondVoucher',
            name: '保证金凭证',
            icon: 'profile',
            // todo: 上线后把这个打开，并和服务端要求的保持一致，本地开发打开时有问题
            permission: 10713,
            component: BondVoucher,
        },
        {
            path: 'offLineAccountList',
            name: '线下渠道分账管理',
            icon: 'profile',
            permission: 10714,
            component: OffLineAccountList,
        },
        {
            path: 'offLineAccountDetail',
            name: '线下渠道分账管理详情',
            icon: 'profile',
            hideInMenu: true,
            component: OffLineAccountDetail,
        },
    ],
};

export default router;
